import { uploadMedia } from './upload-media';
import { deleteMedia } from './delete-media';
import { firebaseAuth, firebaseApp, db, storage } from './firebase-config';

export default {
	uploadMedia: uploadMedia(firebaseApp),
	deleteMedia: deleteMedia(firebaseApp),
	firebaseAuth,
	firebaseApp,
	db,
	storage,
};
